import { useFormikContext } from 'formik';
import { AddSquare } from 'iconsax-react';
import { ChevronDown } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@src/design-system/dropdown-menu';
import { cn } from '@src/design-system/helpers';
import { VARIABLES } from '@features/reminders/data/index.data';
import { appendContentVariable } from './helpers/append-html';
import { syncVariablesFromContent } from './helpers/sync-variables-from-content';

export function AddVariableDropdown() {
  const { setFieldValue, values } = useFormikContext<{ content: string }>();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'cursor-pointer text-gray-900 border opacity-80 hover:opacity-100 border-pale-border flex gap-2 items-center p-2 rounded-xl text-sm'
        )}
      >
        <AddSquare
          size={18}
          variant='TwoTone'
          className='text-secondary-1000'
        />
        Add Variables
        <ChevronDown size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        {VARIABLES.map((opt) => (
          <DropdownMenuItem
            key={opt.value}
            className={cn('capitalize')}
            onClick={() => {
              const newContent = appendContentVariable(
                values.content,
                opt.value
              );
              setFieldValue('content', newContent);
              syncVariablesFromContent(newContent, setFieldValue);
            }}
          >
            {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
